const FilterButton = ({ isActive, onClick, label }) => {
  const activeClass = isActive
    ? "bg-blue-700 text-white"
    : "bg-white text-blue-700";

  return (
    <button
      className={`${activeClass} px-3 py-2 rounded-lg border border-blue-700 text-xs whitespace-nowrap`}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default FilterButton;
